<div>
    <p-scrollPanel [style]="{width: '100%', height: '332px'}" #sc (onScroll)="handleScroll($event)">

        <ng-container *ngIf="isLoading">
            <div class="spinner-container">
                <i class="pi pi-spin pi-spinner"></i>
            </div>
        </ng-container>

        <ol *ngIf="messageList.length > 0" class="discussion p-d-flex p-flex-column" style="padding: 2px;">
            <li *ngFor="let message of messageList; let i = index"
                [ngClass]="(message.id == '01') ? 'self' : 'other'">

                <div *ngIf="i == 0" class="messages_date">
                    {{message.timeTag}}
                </div>
                <div *ngIf="i > 0 && message.timeTag != messageList[i-1].timeTag" class="messages_date">
                    {{message.timeTag}}
                </div>

                <div class="message" *ngFor="let msg of message?.subMsg; let j = index" style="padding-top: 10px;">
                    <div class="message_text">
                        <div [innerHTML]="sanitizeHtml(msg.text)"></div>
                        <div class="attachments" *ngFor="let attachment of msg?.attachments">
                            <a [href]="attachment.url" target="_blank">{{attachment.name}}</a>
                        </div>
                        <div class="msg_time">{{msg.timestamp | date:'h:mm a'}}</div>

                        <div *ngIf="room?.preference_type == 'chatstasy'">
                            <img *ngIf="message.id == '01'"
                                [src]="msg.read_status == 'unread' ? 'assets/images/icons/MessageStaus-Delivered.png' : 'assets/images/icons/MessageStaus-Read.png'"
                                class="message_status_icon bottom-left"
                                alt="Message Status"
                                style="height: 20px; width: 20px;">
                        </div>
                    </div>

                    <div *ngIf="message.id != '01'" class="message_avatar">
                        <p-avatar [label]="msg.sender_name.charAt(0)" shape="circle"
                            [style]="{height: '29px', width: '29px'}">
                        </p-avatar>
                    </div>
                </div>
            </li>
        </ol>

        <div *ngIf="messageList.length == 0" class="room_no_message">
            <h1 style="justify-content: center; align-self: center;">No Messages</h1>
        </div>

    </p-scrollPanel>
</div>
